import type { LinkingMatrix } from '../types';

const ALPHA_LENS_SYMBOL_TARGETS: LinkingMatrix['alpha-lens'] = [
    'trade-pro',
    'trade-pro-multi',
    'alpha-lens',
    'searchalpha',
    'screener',
    'scanner',
    'alerts',
];

export const MATRIX: LinkingMatrix = {
    results: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'locates',
        'lab',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'alerts',
    ],
    watchlist: [
        'watchlist',
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'locates',
        'lab',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'alerts',
    ],
    'order-blotter': [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
    ],
    'trade-pro': ['alerts'],
    'trade-pro-multi': ['alerts'],
    'basket-trading': [],
    'manual-review': [],
    messages: ['order-blotter', 'trade-pro', 'trade-pro-multi', 'messages', 'positions', 'executions', 'orders'],
    positions: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'locates',
        'lab',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'alerts',
    ],
    executions: [
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'executions',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'alerts',
    ],
    accounts: [], // No symbol linking in accounts
    orders: ['order-blotter', 'trade-pro', 'trade-pro-multi', 'messages', 'executions', 'alpha-lens', 'alerts'],
    locates: ['trade-pro', 'trade-pro-multi', 'alpha-lens', 'locates', 'lab', 'searchalpha', 'screener', 'scanner'],
    lab: ['trade-pro', 'trade-pro-multi', 'alpha-lens', 'locates', 'lab', 'searchalpha', 'screener', 'scanner'],
    table: [],
    'alpha-lens': ALPHA_LENS_SYMBOL_TARGETS,
    searchalpha: ['alpha-lens', 'searchalpha', 'screener', 'scanner'],
    scanner: ['alpha-lens', 'searchalpha', 'screener', 'scanner'],
    screener: ['alpha-lens', 'searchalpha', 'screener', 'scanner'],
    news: ['trade-pro', 'trade-pro-multi', 'alpha-lens', 'searchalpha', 'scanner', 'screener'],
    events: ['trade-pro', 'trade-pro-multi', 'alpha-lens', 'searchalpha', 'scanner', 'screener'],
    filings: ['trade-pro', 'trade-pro-multi', 'alpha-lens', 'searchalpha', 'scanner', 'screener'],
    notepad: [], // notepad does not link to or from anything
    'alpha-eye': ALPHA_LENS_SYMBOL_TARGETS,
    platforms: [],
    symbols: [],
    traders: [],
    alerts: [], // alerts receives symbols but does not send them
    backtest: [],
    'tradingview-chart': ['trade-pro', 'trade-pro-multi', 'alpha-lens', 'searchalpha', 'screener', 'scanner', 'alerts'],
};
